export const CLEAR_STATE = 'CLEAR_STATE';

export const GET_AGM_PRESENCE = 'GET_AGM_PRESENCE';
export const GET_AGM_PRESENCE_SUCCESS = 'GET_AGM_PRESENCE_SUCCESS';
export const GET_AGM_PRESENCE_ERROR = 'GET_AGM_PRESENCE_ERROR';

export const GET_PRESENCE = 'GET_PRESENCE';
export const GET_PRESENCE_SUCCESS = 'GET_PRESENCE_SUCCESS';
export const GET_PRESENCE_ERROR = 'GET_PRESENCE_ERROR';

export const SAVE_AGM_PRESENCE = 'SAVE_AGM_PRESENCE';
export const SAVE_AGM_PRESENCE_SUCCESS = 'SAVE_AGM_PRESENCE_SUCCESS';
export const SAVE_AGM_PRESENCE_ERROR = 'SAVE_AGM_PRESENCE_ERROR';

export const UPDATE_AGM_PRESENCE = 'UPDATE_AGM_PRESENCE';
export const UPDATE_AGM_PRESENCE_SUCCESS = 'UPDATE_AGM_PRESENCE_SUCCESS';
export const UPDATE_AGM_PRESENCE_ERROR = 'UPDATE_AGM_PRESENCE_ERROR';

export const DELETE_AGM_PRESENCE = 'DELETE_AGM_PRESENCE';
export const DELETE_AGM_PRESENCE_SUCCESS = 'DELETE_AGM_PRESENCE_SUCCESS';
export const DELETE_AGM_PRESENCE_ERROR = 'DELETE_AGM_PRESENCE_ERROR';

export const DOWNLOAD_AGM_PRESENCE = 'DOWNLOAD_AGM_PRESENCE';
export const DOWNLOAD_AGM_PRESENCE_SUCCESS = 'DOWNLOAD_AGM_PRESENCE_SUCCESS';
export const DOWNLOAD_AGM_PRESENCE_ERROR = 'DOWNLOAD_AGM_PRESENCE_ERROR';



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Reports/AGM/constants.js